/**
 * Aplica sugestão de IA ao estado do formulário de regras de automação.
 */

export function buildFormPatchFromAiSuggestion(suggestion, { userId } = {}) {
  if (!suggestion || typeof suggestion !== "object") return null;

  return {
    descricao: suggestion.descricao || "",
    id_objeto: suggestion.id_objeto != null ? suggestion.id_objeto : "",
    id_condicao: suggestion.id_condicao != null ? suggestion.id_condicao : "",
    condicoes: suggestion.condicoes && typeof suggestion.condicoes === "object" ? suggestion.condicoes : {},
    condicoes_labels:
      suggestion.condicoes_labels && typeof suggestion.condicoes_labels === "object"
        ? suggestion.condicoes_labels
        : {},
    acoes: Array.isArray(suggestion.acoes)
      ? suggestion.acoes.map((a) => ({
          id: a.id,
          values: a.values && typeof a.values === "object" ? a.values : {},
          labels: {},
        }))
      : [],
    id_usuario: userId,
    id_usuario_ultima_alteracao: userId,
  };
}

export function mergeAiSuggestionIntoForm(currentForm, suggestion, { userId } = {}) {
  const patch = buildFormPatchFromAiSuggestion(suggestion, { userId });
  if (!patch) return currentForm;

  return {
    ...currentForm,
    ...patch,
    prioridade: currentForm?.prioridade ?? "",
    fila: currentForm?.fila ?? "",
    ordem: currentForm?.ordem ?? "",
    break: currentForm?.break ?? 0,
    webhook: currentForm?.webhook ?? "",
    token: currentForm?.token ?? "",
  };
}
